<template>
  <div class="product-bundle-container">
    <div :id="product.bundle_id" class="product-item-container" :class="brand.name">
      <router-link class="ecomm-item-container" :class="brand.name" :to="{ name: 'servicedetail', params: { id: this.product.bundle_id } }">
        <img class="ecomm-image-container"  alt="ecom container image" width="384" height="256" :class="brand.name" v-bind:src="imageUrl">
        <div id="ecomm-overview" class="ecomm-overview" :class="brand.name">
          <div class="ecomm-title"> {{ product.title }}</div>
          <div class="ecomm-sub-title"> {{ product.sub_title }}</div>
          <div class="ecomm-bundle-details">
            <div>Includes:</div>
            <div class="product-description" v-for="(product, index) in bundleProducts" :key="index">
              {{ product }}
            </div>
          </div>
          <div class="purchase-price" :class="brand.name">{{ displayBundleSavings }} </div>
          <div class="cta">
            <div class="ss-button" :class="brand.name">View Details</div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { ImageModel } from '@/models/image-model'

export default {
  name: 'BundleItem',
  props: {
    brand: Object,
    product: Object,
    inIframe: Boolean,
    apiProcessing: Boolean
  },
  computed: {
    bundleProducts () {
      return this.$store.getters['productVariants/bundleProductTitles'](this.product.bundle_id)
    },
    imageUrl: function () {
      return ImageModel.makeProductImageUrl({ brandName: this.brand.name, imageName: this.product.image_name })
    },
    displayBundleSavings () {
      let displayPromoTag
      if (this.product.discount_type === 'dollar') {
        displayPromoTag = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.product.discount_value) + ' Off'
      } else if (this.product.discount_type === 'percent') {
        displayPromoTag = 'Save ' + this.product.discount_value + '%'
      } else { // discount_type = fixed and anything else
        displayPromoTag = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.product.discount_value)
      }
      return displayPromoTag
    }
  }
}
</script>

<style scoped>
.product-item-container {
  width: 100%;
  text-align: left;
  box-sizing: border-box; /* needed to size elements in container*/
}
.ecomm-item-container {
  position: relative;
  display: grid;
  flex-direction: column;
  text-align: center;
  text-decoration: none;
  overflow: auto;
}
.ecomm-image-container {
  width: 100%;
  height: auto;
  position:relative;
  overflow:hidden;
  padding: 0px;
  align-self: center;
  z-index: 1;
}

.ecomm-overview {
  display: flex;
  flex-direction: column;
  background-color: #efefef;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
  text-decoration: none;
  overflow: auto;
  padding: 5%;
  row-gap: 20px;
  text-align: center;
  justify-content: space-between;
  z-index: 2;
}

.ecomm-overview.bmw,
.ecomm-overview.mini {
  justify-content: left;
  text-align: left;
}
.ecomm-title {
  width: 100%;
  font-size: 1.2em;
  color: #000000;
  font-weight: bold;
  white-space: normal;
  word-wrap: break-word;
}
.ecomm-sub-title {
  width: 100%;
  height: 100%;
  font-size: 1em;
  white-space: normal;
  word-wrap: break-word;
  color: var(--variant-color);
}
.ecomm-bundle-details {
  width: 100%;
  height: 100%;
  color: #000000;
  white-space: normal;
  word-wrap: break-word;
}
.ecomm-image-container:hover {
  opacity: 0.9
}
.purchase-price {
  font-size: 1.2em;
  font-weight: bold;
  color: var(--variant-color);
}
.cta {
  bottom: 0;
}
/* styles for different screen widths follow */
@media only screen and (min-width: 576px) {
}
@media only screen and (min-width: 768px) {
  .product-item-container {
    display: flex;
    width: 100%;
    height: auto;
    text-align: center;
    align-items: center;
    align-self: center;
    justify-content: center;
    justify-self: center;
  }
  .ecomm-item-container {
    flex-direction: row;
    grid-template-columns: 40% auto;
    background-color: #efefef;
    row-gap:10px;
  }
  .ecomm-image-container {
    width: auto;
    height: 100%;
  }
  .ecomm-title {
    font-size: 1.4em;
  }
}
@media only screen and (min-width: 992px) {
  .purchase-price {
    font-size: 1.4em;
  }
  .ecomm-item-container {
    grid-template-columns: 40% auto;
    width: 100%;
  }
}
@media only screen and (min-width: 1200px) {
  .ecomm-item-container {
    grid-template-columns: 500px auto;
    width: 80%;
  }
}
</style>
